import styled from "styled-components";
import colors from "../../../../../utils/colors";

const StyledInputWrapper = styled.div`
  display: block;
  width: 100%;
  align-self: flex-start;
  position: relative;

  ${props =>
    props.half &&
    `
    width: calc(50% - 0.625rem);
  `} ${props =>
    props.inline &&
    `
    width: auto;
    display: inline-block;
    vertical-align: middle;
  `}

  border-radius: 0.3125rem;
  &.error {
    background: ${colors.BRAND_RED_LIGHTEST};
  }

  svg {
    background: white;
    stroke: ${colors.WHITE};
    position: absolute;
    right: 0.625rem;
    top: 0.75rem;
    pointer-events: none;
  }
`;

export default StyledInputWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledInputWrapper.js